export default "__VITE_ASSET__0bbf41db__"